
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/aircall",
      function () {
        return require("private-next-pages/agents/aircall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/aircall"])
      });
    }
  